(function ($) {
    $(document).ready(function () {
        const initializeSliders = function () {
            const getSection = $('.testimonial');

            if (getSection.length) {
                const blockquote = $('.testimonial .wrapper');

                // Destroy any previous instances of Slick
                if (blockquote.hasClass('slick-initialized')) {
                    blockquote.slick('unslick');
                }

                // Reinitialize the sliders
                blockquote.slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    dots: false,
                    arrows: true,
                    prevArrow: $('.testimonial .button-wrap .pre-btn'),
                    nextArrow: $('.testimonial .button-wrap .next-btn'),
                    draggable: true,
                });
            }
        };

        // Initialize sliders on document ready
        initializeSliders();

        // Reinitialize sliders on window resize
        $(window).resize(function () {
            initializeSliders();
        });
    });
})(jQuery);